(function ($) {

  // -------------------
  // Menu
  // -------------------

  $(window).on('scroll touchmove', function () {
    $('header').toggleClass('scroll', $(document).scrollTop() > 10);
  });

  $('header').toggleClass('scroll', $(document).scrollTop() > 10);


  // function navScroll() {
  //   var height = $(window).scrollTop();

  //   if (height > 10) {
  //     $('header').addClass('scroll');
  //   }

  //   if (height < 10) {
  //     $('.site-header').removeClass('scroll');
  //   }
  // }

  // $(document).ready(function () {
  //   navScroll();
  // });

  // $(window).scroll(function () {
  //   navScroll();
  // });

  $('.menu-wrap').on('click touchend', function (ev) {
    $('body').toggleClass('open-menu');
    $('li').removeClass('sub-menu-open');
    $('.sub-menu').css('display', 'none');

    ev.stopPropagation();
    ev.preventDefault();
  });


  $('.search-icon').click(function () {
    $('header').addClass('open-search');
    $('#s').focus();
  });

  $('.close-search').click(function () {
    $('header').removeClass('open-search');
  });

  $('header nav li a').on('click', function () {
    $('body').removeClass('open-menu');
    $('li').removeClass('sub-menu-open');
    $('.sub-menu').css('display', 'none');
  });

  $(window).on('resize', function () {
    if (window.innerWidth >= 1070) {
      $('body').removeClass('open-menu');
      $('li').removeClass('sub-menu-open');
      if (!$('header').hasClass('menu-open')) {
        $('.sub-menu').css('display', '');
      }
    }
    if (window.innerWidth < 1070) {
      $('header').removeClass('open-search');
    }
  });


  $(window).on('resize', function () {
    if (window.innerWidth <= 767) {

    } else {

    }
  });

  $(".bag").click(function () {
    $(".widget_shopping_cart_content").fadeToggle();
  });

  // $(".js-close-modal").click(function () {
  //   $(".widget_shopping_cart_content").removeClass("visible");
  // });

  $(document).click(function (event) {
    //if you click on anything except the modal itself or the "open modal" link, close the modal
    if (!$(event.target).closest(".widget_shopping_cart_content,.bag").length) {
      $("body").find(".widget_shopping_cart_content").css({'opacity':'', 'display':''});
    }
  });



  // $('.bag').on('click', function () {
  //   $('.page-wrap').toggleClass('cart-open');
  //   $('.widget_shopping_cart_content').fadeToggle();
  // });

  // $('.page-wrap').on('click', function () {
  //   if ($('.page-wrap').hasClass('cart-open')) {
  //     $('.widget_shopping_cart_content').fadeToggle();
  //     $('.page-wrap').removeClass('cart-open');
  //   }
  // });

  var urlPathArr = window.location.href.split('/');

  var anim_character = lottie.loadAnimation({
    container: document.getElementById('anim-character'),
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path:
      urlPathArr[0] +
      '/wp-content/themes/bag/assets/js/anim-character.json'
  });

  setTimeout(function () { anim_character.play(); }, 1600);

  var anim_hero = lottie.loadAnimation({
    container: document.getElementById('anim-hero'),
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path:
      urlPathArr[0] +
      '/wp-content/themes/bag/assets/js/anim-hero.json'
  });

  var anim_about = lottie.loadAnimation({
    container: document.getElementById('anim-bout'),
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path:
      urlPathArr[0] +
      '/wp-content/themes/bag/assets/js/anim-about.json'
  });

  var anim_rewards = lottie.loadAnimation({
    container: document.getElementById('anim-rewards'),
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path:
      urlPathArr[0] +
      '/wp-content/themes/bag/assets/js/anim-rewards.json'
  });

  if (!$('body').hasClass('home')) {
    var anim_header = lottie.loadAnimation({
      container: document.getElementById('anim-header'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path:
        urlPathArr[0] +
        '/wp-content/themes/bag/assets/js/anim-header.json'
    });
  }

  $('.slider-about').each(function () {
    $(this).slick({
      dots: true,
      slidesToShow: 1,
      speed: 300,
      fade: true,
      arrows: false,
      autoplay: false,
      dotsClass: 'slick-dots container',
    });
  });


		/*
		if you want to use one of the easing effects:
		$('html, body').stop().animate({
			scrollLeft: $($anchor.attr('href')).offset().left
		}, 1500,'easeInOutExpo');
		 */
  // $('.woocommerce-MyAccount-navigation').stop().animate({
  //     scrollLeft: $('.is-active').offset().left
  //   }, 0);

  if ($('nav').hasClass('woocommerce-MyAccount-navigation')) {
    if (window.innerWidth <= 991) {
      $('.woocommerce-MyAccount-navigation ul').animate({
        scrollLeft:
          $('li.is-active').position().left -
          $('li.is-active').width()
      }, 'slow');
    }
  }


  //Shop categories menu

  $('aside ul.children').insertAfter($('aside ul.product-categories'));

  $('.cat-item-211, .cat-item-231, .cat-item-247, .cat-item-216, .cat-item-236, .cat-item-252').before('<div class="sub-sections">Sections</div>');

  $('.cat-item-207, .cat-item-227, .cat-item-243').before('<div class="sub-sections">Matières</div>');

  $('.cat-item-209, .cat-item-229, .cat-item-245').before('<div class="sub-sections">Compétences</div>');

  $('.cat-item-222, .cat-item-238, .cat-item-254').before('<div class="sub-sections">Champs</div>');


  //DEV


  // $( '.cat-item-225' ).before('<div class="sub-sections">Matières</div>');

  // $( '.cat-item-231' ).before('<div class="sub-sections">Compétences</div>');

  // $( '.cat-item-235' ).before('<div class="sub-sections">Sections</div>');

  // $( '.cat-item-240' ).before('<div class="sub-sections">Champs</div>');

  if ($('form').hasClass('woocommerce-form-login')) {
    $('h2').css('display', 'none');
  }


})(jQuery);
